import React from 'react'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import {
    tituloEstudoGarantiaCliente,
    tituloEstudoGarantiaConjuge,
} from './EstudoService'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
} from '../../../business-components/Formata/Formata'

import {
    DivFormEstudo,
} from '../../../business-components/Div/Div'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    SvgIconRecursosFinanceiros,
} from '../../../business-components/SvgIcon/SvgIconGarantiasAtuais/SvgIconGarantiasAtuais'

import {
    dadosCompletosCliente,
    dadosCompletosConjuge,
} from '../cliente-form/ClienteService'

import {
    relatorioModoApresentacao,
} from './EstudoService'

import {
    CardGridEstudoTabelaPadrao,
} from './EstudoComp'



const EstudoFormGarantiasRecursosFinanceiros = ( { values, estudo, report, jsonConfiguracao, indInicial, indFinal } ) => {

    const GarantiasRecursosFinanceiros = () => {

        const temValorReservadoPVS =
            estudo.current.recursosFinanceiros[estudo.current.recursosFinanceiros.length - 1].valorReservadoPVSTotal > 0

        let headList = [
            {
                colSpan: 10,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.tipoRecursoFinanceiro, report),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valor, report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.valorAporteDividendosContribuicao, report),
            },
        ]

        if (temValorReservadoPVS) {

            headList.push(
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.valorReservadoPVSQuebraEspecial, report),
                },
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.saldoNaoReservadoQuebraEspecial, report),
                },
            )
        }

        if (dadosCompletosCliente(values)) {
            headList.push(
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                        tituloEstudoGarantiaCliente(values), report),
                },
            )
        }

        if (dadosCompletosConjuge(values)) {
            headList.push(
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                        tituloEstudoGarantiaConjuge(values), report),
                },
            )
        }

        return (
            <TableExibeDados
                report={report}
            >
                <TableHeadExibeDados
                    report={report}
                >
                    <TableRowHeadExibeDados
                        dados={headList}
                    />
                </TableHeadExibeDados>

                <TableBodyExibeDados>
                    {estudo.current.recursosFinanceiros?.map((item, ind) => {

                        let colSpan = 0

                        return (!indFinal || (ind >= indInicial && ind <= indFinal)) && (
                            <TableRowBodyExibeDados
                                key={ind}
                                report={report}
                            >
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                    primeiraColuna={true}
                                >
                                    {item.descricao}
                                </TableCellBodyExibeDados>
                                
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.valor}
                                </TableCellBodyExibeDados>
                            
                                <TableCellBodyExibeDados
                                    colSpan={headList[colSpan++].colSpan}
                                >
                                    {item.valorAporteDividendosContribuicao}
                                </TableCellBodyExibeDados>

                                {temValorReservadoPVS && (
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.valorReservadoPVS}
                                    </TableCellBodyExibeDados>
                                )}

                                {temValorReservadoPVS && (
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.saldoNaoReservado}
                                    </TableCellBodyExibeDados>
                                )}

                                {dadosCompletosCliente(values) && (
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.valorGarantiaCliente}
                                    </TableCellBodyExibeDados>
                                )}
                                
                                {dadosCompletosConjuge(values) && (
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {item.valorGarantiaConjuge}
                                    </TableCellBodyExibeDados>
                                )}
                            </TableRowBodyExibeDados>
                        )
                    })}
                </TableBodyExibeDados>
            </TableExibeDados>
        )
    }

    return (
        <DivFormEstudo>
            {report || relatorioModoApresentacao(values)
                ?
                    //<div
                    //    className={(relatorioModoApresentacao(values) ? 'mt-10 ml-5 mr-5' : '')} // mudança da fonte: acrescentou mt-10
                    //>
                    <>
                        <div
                            className={CLASSNAME().formataReportDetalhamento}
                            align='left'
                        >
                            {jsonConfiguracao && jsonConfiguracao.estudoReportDetalhamentoRecursosFinanceirosTextoCabecalho
                                ?
                                    <>
                                        {jsonConfiguracao.estudoReportDetalhamentoRecursosFinanceirosTextoCabecalho}
                                        <br/>
                                        <br/>
                                        <br/>
                                    </>
                                :
                                    MESSAGE().estudoReportDetalhamentoRecursosFinanceirosTextoCabecalho
                            }
                        </div>

                        <GarantiasRecursosFinanceiros />
                    </>
                    //</div>
                :
                    <CardGridEstudoTabelaPadrao
                        values={values}
                        SvgIcon={SvgIconRecursosFinanceiros}
                        label={LABEL.recursosFinanceiros}
                        helpTextMorte={HELPTEXT.estudoRecursosFinanceiros}
                        helpTextInvalidez={HELPTEXT.estudoRecursosFinanceiros}
                        component={<GarantiasRecursosFinanceiros/>}
                        popup={true}
                    />
            }
        </DivFormEstudo>
    )
}

export default EstudoFormGarantiasRecursosFinanceiros